import React, { useState } from "react";
import { useIntl } from "react-intl";
import { AlertTriangle, CopyV2 } from "@piiqtechnologies/svg-icons";
import { PeekAlert, PeekBox, PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import messages from "../../messages.i18n";
import { CustomSubtopicsWarningDialog } from "./CustomSubtopicsWarningDialog";
const CustomSubtopicWarningIcon = () => {
    return (React.createElement(PeekBox, { bgcolor: "orange.50", borderRadius: "100%", px: 1.5, py: 1 },
        React.createElement(PeekTypography, { variant: "h2", color: "warning.main" },
            React.createElement(AlertTriangle, null))));
};
const CustomSubtopicWarningContent = () => {
    const intl = useIntl();
    return (React.createElement(PeekStack, { direction: "column" },
        React.createElement(PeekTypography, { fontWeight: "fontWeightMedium" }, intl.formatMessage(messages.warningTitle)),
        React.createElement(PeekTypography, null, intl.formatMessage(messages.warningDescription))));
};
const CustomSubtopicWarningAction = ({ onClick }) => {
    const intl = useIntl();
    return (React.createElement(PeekButton, { size: "large", variant: "outlined", color: "info", startIcon: React.createElement(CopyV2, null), onClick: onClick, sx: { whiteSpace: "nowrap" } }, intl.formatMessage(messages.warningActionButton)));
};
export const CustomSubtopicWarning = ({ onConfirm, loading } = {}) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const handleConfirm = onConfirm
        ? () => {
            onConfirm();
            setIsDialogOpen(false);
        }
        : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekAlert, { color: "warning", sx: { m: 1.5, mb: 0 }, action: React.createElement(CustomSubtopicWarningAction, { onClick: () => setIsDialogOpen(true) }) },
            React.createElement(PeekStack, { width: "100%", direction: "row", alignItems: "center", gap: 2 },
                React.createElement(CustomSubtopicWarningIcon, null),
                React.createElement(CustomSubtopicWarningContent, null))),
        React.createElement(CustomSubtopicsWarningDialog, { open: isDialogOpen, onClose: () => setIsDialogOpen(false), onConfirm: handleConfirm, loading: loading })));
};
export default CustomSubtopicWarning;
